import flowchart from 'flowchart.js';
import convertRough from '../convertRough';

export default async (input, options = {}) => {
  await flowchart
    .parse(input).drawSVG('flowchart-unshow');
  const svg = document.getElementById('flowchart-unshow').firstChild;
  return convertRough(svg, options);
}